import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import Moment from "moment";
import User from '_class/User';
import { getActiveSchool } from 'helpers/localstorage';
import { deleteTeacherRole, addTeacherRole, getUserInfo } from 'actions/user';
import { getSchoolSubjectTeachers } from 'actions/schools';
import Modal from 'containers/Modals/Modal';
import SubjectTeachersForm from 'containers/Forms/SubjectTeachersForm';
import TeacherRoleForm from 'containers/Forms/TeacherRole';
import { DataList, Spinner } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Icon, Button, getActiveLanguage } from '@haldor/ui';

var Subjects = /*#__PURE__*/function (_Component) {
  _inherits(Subjects, _Component);

  var _super = _createSuper(Subjects);

  function Subjects(props) {
    var _this;

    _classCallCheck(this, Subjects);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.getActiveSchoolTeachers();
    });

    _defineProperty(_assertThisInitialized(_this), "userSchoolAdmin", function (schoolId) {
      if (_this.props.currentUser.roles != null && _this.props.currentUser.roles.length > 0) {
        var schoolAdministrator = _this.props.currentUser.roles.find(function (role) {
          return role.roleId.toUpperCase() == "SCHOOL_ADMINISTRATOR" && role.referenceId == schoolId || role.roleId.toUpperCase() == "SYSADMIN";
        });

        if (schoolAdministrator != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveSchoolTeachers", function () {
      _this.setState({
        loading: true
      });

      var activeSchool = getActiveSchool(_this.props.currentUser.id);

      _this.props.getSchoolSubjectTeachers(activeSchool).then(function () {
        _this.setState({
          loading: false
        });

        var subjects = [];
        var subjectTeachersUserId = [];

        _this.props.subjectTeacher.forEach(function (s) {
          subjectTeachersUserId.push(s.userId);
          var subject = subjects.find(function (x) {
            return x.subjectId == s.subjectId;
          });

          if (subject == null) {
            subject = {
              title: s.title,
              subjectId: s.subjectId,
              subjectCode: s.subjectCode,
              typeOfSchooling: s.typeOfSchooling,
              subjectTeachersUserId: [s.userId],
              subjectTeachers: [],
              nrOfSubjectTeachers: 1
            };
            subjects.push(subject);
          } else {
            var userId = subject.subjectTeachersUserId.find(function (uid) {
              return s.userId == uid;
            });

            if (userId == null) {
              subject.nrOfSubjectTeachers = subject.nrOfSubjectTeachers + 1;
              subject.subjectTeachersUserId.push(s.userId);
            }
          }
        });

        subjects = subjects.sort(function (a, b) {
          return a.title > b.title ? 1 : b.title > a.title ? -1 : 0;
        });

        _this.state.noPermissionSubjects.forEach(function (s) {
          var subject = subjects.find(function (x) {
            return x.subjectId == s.subjectId;
          });

          if (subject == null) {
            subjects.push(s);
          }
        });

        _this.setState({
          loading: false,
          subjects: subjects
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (modalType) {
      _this.setState({
        modal: !_this.state.modal,
        modalType: modalType
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubjectRoleRow", function (subject) {
      var activeSchool = getActiveSchool(_this.props.currentUser.id);
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: subject.subjectCode,
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          _this.userSchoolAdmin(activeSchool) ? _this.onEditSubjectTeacher(subject) : null;
        }
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, subject.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('subject-code')
      }, subject.subjectCode), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('school')
      }, _this.props.translate(subject.typeOfSchooling)), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('teacher')
      }, subject.nrOfSubjectTeachers));
    });

    _defineProperty(_assertThisInitialized(_this), "onEditSubjectTeacher", function (subject) {
      _this.setState({
        subject: subject
      });

      _this.toggleModal('SubjectTeachersForm');
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectTeachersSubmit", function (subject, subjectTeachers) {
      var activeSchool = getActiveSchool(_this.props.currentUser.id);
      var promises = [];
      subject.subjectTeachersUserId.forEach(function (uid) {
        var teacherIndex = subjectTeachers.findIndex(function (teacher) {
          return uid == teacher.userId;
        });

        if (teacherIndex == -1) {
          promises.push(_this.props.deleteTeacherRole(uid, subject.subjectId, activeSchool));
        }
      });
      subjectTeachers.forEach(function (teacher) {
        var teacherIndex = subject.subjectTeachersUserId.findIndex(function (uid) {
          return uid == teacher.userId;
        });

        if (teacherIndex == -1) {
          var subjectTeacher = {
            UserId: teacher.userId,
            SubjectId: subject.subjectId,
            SubjectCode: subject.subjectCode,
            typeOfSchooling: subject.typeOfSchooling,
            Title: subject.title,
            SchoolId: activeSchool
          };
          promises.push(_this.props.addTeacherRole(teacher.userId, subjectTeacher));
        }
      });

      var noPermissionSubjectsIndex = _this.state.noPermissionSubjects.findIndex(function (n) {
        return n.subjectId == subject.subjectId;
      });

      if (noPermissionSubjectsIndex > -1) {
        var noPermissionSubjects = _this.state.noPermissionSubjects;
        noPermissionSubjects.splice(noPermissionSubjectsIndex, 1);

        _this.setState({
          noPermissionSubjects: noPermissionSubjects
        });
      }

      Promise.all(promises).then(function () {
        _this.getActiveSchoolTeachers();

        _this.setState({
          modal: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTeacherRoleSubmit", function (subjects) {
      var noPermissionSubjects = _this.state.noPermissionSubjects;
      var stateSubjects = _this.state.subjects;
      subjects.forEach(function (s) {
        var subject = stateSubjects.find(function (x) {
          return x.subjectId == s.subjectId;
        });

        if (subject == null) {
          subject = {
            title: s.title,
            subjectId: s.id,
            subjectCode: s.subjectCode,
            subjectTeachersUserId: [],
            subjectTeachers: [],
            typeOfSchooling: s.typeOfSchooling,
            nrOfSubjectTeachers: 0
          };
          stateSubjects.push(subject);
        }

        subject = noPermissionSubjects.find(function (x) {
          return x.subjectId == s.id;
        });

        if (subject == null) {
          subject = {
            title: s.title,
            subjectId: s.id,
            subjectCode: s.subjectCode,
            subjectTeachersUserId: [],
            subjectTeachers: [],
            typeOfSchooling: s.typeOfSchooling,
            nrOfSubjectTeachers: 0
          };
          noPermissionSubjects.push(subject);
        }
      });

      _this.setState({
        modal: false,
        stateSubjects: stateSubjects,
        noPermissionSubjects: noPermissionSubjects
      });
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      modal: false,
      modalType: "",
      noPermissionSubjects: [],
      subjects: [],
      subject: {}
    };
    return _this;
  }

  _createClass(Subjects, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);
      var activeSchool = getActiveSchool(this.props.currentUser.id);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "temp-subject-administration"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        overridePrompt: true,
        title: this.state.modalType == "SubjectTeachersForm" ? this.props.translate('add-subjectteacher') + " " + this.state.subject.title : this.props.translate('add-subject'),
        isOpen: this.state.modal,
        type: "small"
      }, this.state.modalType == "SubjectTeachersForm" ? /*#__PURE__*/React.createElement(SubjectTeachersForm, {
        subject: this.state.subject,
        onSubjectTeachersSubmit: this.onSubjectTeachersSubmit
      }) : /*#__PURE__*/React.createElement(TeacherRoleForm, {
        previousTeacherRoles: this.props.subjectTeacher,
        onTeacherRoleSubmit: this.onTeacherRoleSubmit
      })), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(DataList, {
        data: this.state.subjects,
        renderRow: this.renderSubjectRoleRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results'));
        }
      }), user.isAdministrator() ? /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: '20px',
          "float": 'right'
        },
        type: "secondary",
        onClick: function onClick() {
          return _this2.toggleModal('AddSubjectForm');
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate("add-subject")) : null);
    }
  }]);

  return Subjects;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    users: state.user.info,
    school: state.School.active,
    subjectTeacher: state.School.subjectTeacher
  };
}

export default connect(mapStateToProps, {
  getSchoolSubjectTeachers: getSchoolSubjectTeachers,
  deleteTeacherRole: deleteTeacherRole,
  addTeacherRole: addTeacherRole,
  getUserInfo: getUserInfo
})(Subjects);